var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Variant=Outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.01662 11.1645C4.06662 6.79251 8.02127 4.5 11.9831 4.5C16.6362 4.5 20.6443 7.53129 23.0091 11.1836L23.0102 11.1853C23.1667 11.4285 23.2499 11.7115 23.2499 12.0007C23.2499 12.2893 23.167 12.5719 23.0111 12.8147C20.6483 16.5141 16.6661 19.5 11.9831 19.5C7.25032 19.5 3.34483 16.5203 0.987915 12.8317C0.827766 12.583 0.744702 12.2925 0.749197 11.9968C0.753702 11.7002 0.845999 11.4117 1.01443 11.1676L1.01662 11.1645ZM2.24903 12.0196L2.25111 12.0228C4.42804 15.4304 7.91716 18 11.9831 18C16.0036 18 19.5679 15.4195 21.7474 12.0065L21.7489 12.0043C21.7495 12.0032 21.7499 12.002 21.7499 12.0007C21.7499 12.0002 21.7498 11.9996 21.7497 11.9991C21.7496 11.9985 21.7493 11.9979 21.749 11.9973C19.5611 8.61915 15.9676 6 11.9831 6C8.63897 6 5.09927 7.93555 2.24903 12.0196ZM11.9991 9C10.3422 9 8.99907 10.3431 8.99907 12C8.99907 13.6569 10.3422 15 11.9991 15C13.6559 15 14.9991 13.6569 14.9991 12C14.9991 10.3431 13.6559 9 11.9991 9ZM7.49907 12C7.49907 9.51472 9.51379 7.5 11.9991 7.5C14.4844 7.5 16.4991 9.51472 16.4991 12C16.4991 14.4853 14.4844 16.5 11.9991 16.5C9.51379 16.5 7.49907 14.4853 7.49907 12Z",
    fill: "#006DB3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOutline);
export default __webpack_public_path__ + "static/media/Eye_Outline.ddef13e8a7d7aa10bdcf34939922719e.svg";
export { ForwardRef as ReactComponent };